import React, { useEffect, useState } from "react";
import { Icon, Input, Select, Button } from "antd";
import style from "../solo.module.sass";
import "../create/flow.css"
import CodeEditor from "../codeEditor/CodeEditor"
import VariableAcl from "./VariableAcl";
import variableAclIcon from "../../../../../assets/svg/solo/variableAclConfigured.svg"
import emptyVariableAclIcon from "../../../../../assets/svg/solo/variableAclNotConfigured.svg"
// import _ from "lodash";

const { Option } = Select;

interface Service {
    serviceName?: string,
    serviceKey?: string
}

const WebHook = (props: any) => {/* eslint-disable */
    const { forms, soloServices, nodeDetail, elements, widgetDrawer, showVariableAcl, setShowVariableAcl, setAclIcon } = props
    const [webHookName, setWebHookName]: any = useState(null);
    const [name, setName]: any = useState(null)
    const [nodes, setNodes]: any = useState(null);
    const [nextNode, setNextNode]: any = useState(null);
    const [webHookProperty, setWebHookProperty]: any = useState({ nodeId: null, name: "" })
    const [selectedForm, setSelectedForm] = useState(null)
    const [formKey, setFormKey] = useState(null)
    const [apiResponseHandler, setApiResponseHandler]: any = useState(null)
    const [webhookHandler, setWebhookHandler]: any = useState(null)
    const [apiResponseHandlerService, setApiResponseHandlerService] = useState<Service>({})
    const [webhookHandlerService, setWebhookHandlerService] = useState<Service>({})
    const [emailSubject, setEmailSubject]: any = useState(null)
    const [emailBody, setEmailBody]: any = useState(null)
    const [showEmailBodyEditor, setShowEmailBodyEditor] = useState<boolean>(false)
    const [variableAcl, setVariableAcl] = useState({});
    const [setupActiveTab, setSetupActiveTab] = useState("freeze")
    const [teardownActiveTab, setTeardownActiveTab] = useState("freeze")

    useEffect(() => {
        if (forms) {
            forms.map((f: any) => {
                return (f.formName === selectedForm) &&
                    setFormKey(f.formKey)
            })
        }
    }, [selectedForm])

    useEffect(() => {
        if (soloServices) {
            soloServices.map((s: any) => {
                if (apiResponseHandler && apiResponseHandler === s.name) {
                    return setApiResponseHandlerService({ serviceName: s.name, serviceKey: s.serviceKey })
                }
            })
        }
    }, [apiResponseHandler])

    useEffect(() => {
        if (soloServices) {
            soloServices.map((s: any) => {
                if (webhookHandler && webhookHandler === s.name) {
                    return setWebhookHandlerService({ serviceName: s.name, serviceKey: s.serviceKey })
                }
            })
        }
    }, [webhookHandler])


    useEffect(() => {
        let targetNodeFind: any;
        const findNextNode = elements.filter((el: any) => { return (el.source === nodeDetail.id) })
        targetNodeFind = elements.filter((el: any) => { return (el.target === nextNode) })
        if (findNextNode.length) {
            setNextNode(findNextNode[0].target)
        } else if (findNextNode.length === 0 && targetNodeFind.length === 0) {
            setNextNode("")
        }
        let arr: any = []
        elements.forEach((e: any) => {
            if (e.data && e.data.type && e.data.type !== "start" && e.data.type !== "error" && e.id !== props.nodeDetail.id) {
                arr.push(e)
                setNodes(arr)
            }
        })
    }, [elements])

    useEffect(() => {
        props.onUpdateProperties(webHookProperty)
    }, [webHookProperty])

    useEffect(() => {
        if (webHookName) {
            setWebHookProperty({
                nodeId: nodeDetail.id,
                name: webHookName,

            })
        }
    }, [webHookName])

    useEffect(() => {
        let name = nodeDetail.id
        let sForm = null
        let fKey = null
        let sService = null
        let selectedWebhookHandler = null
        let serv = {}
        let webhookServ = {}
        let eSub, eBody = ""
        let acl = {}
        setSetupActiveTab("freeze")
        setTeardownActiveTab("freeze")
        setAclIcon(emptyVariableAclIcon)
        setShowVariableAcl(false)
        if (nodeDetail.data.propertyDetails) {
            if (nodeDetail.data.propertyDetails.variableAcl?.setup?.freeze || nodeDetail.data.propertyDetails.variableAcl?.setup?.unfreeze ||
                nodeDetail.data.propertyDetails.variableAcl?.setup?.hide || nodeDetail.data.propertyDetails.variableAcl?.setup?.unhide ||
                nodeDetail.data.propertyDetails.variableAcl?.teardown?.freeze || nodeDetail.data.propertyDetails.variableAcl?.teardown?.unfreeze ||
                nodeDetail.data.propertyDetails.variableAcl?.teardown?.hide || nodeDetail.data.propertyDetails.variableAcl?.teardown?.unhide) {
                setAclIcon(variableAclIcon)
            }
            const { propertyDetails } = nodeDetail.data
            if (propertyDetails && propertyDetails.apiResponseHandler) {
                sForm = nodeDetail.data.propertyDetails.selectedForm || null
                sService = nodeDetail.data.propertyDetails.apiResponseHandler ? nodeDetail.data.propertyDetails.apiResponseHandler.serviceName : null
                selectedWebhookHandler = nodeDetail.data.propertyDetails.webhookHandler ? nodeDetail.data.propertyDetails.webhookHandler.serviceName : null
            } else {
                const { requestService: responseHandler } = nodeDetail.data.propertyDetails || {}
                const { webhookHandler: webhookHandlerServ } = nodeDetail.data.propertyDetails || {}
                let f = forms && forms.find((f: any) => { return f.formKey === nodeDetail.data.propertyDetails.formKey })
                if (f) {
                    sForm = f.formName
                }
                if (responseHandler) {
                    let s = soloServices && soloServices.find((s: any) => { return s.serviceKey === responseHandler.serviceKey })
                    if (s) {
                        sService = s.name
                    }
                }
                if (webhookHandlerServ) {
                    let webhookHandlerFind = soloServices && soloServices.find((s: any) => { return s.serviceKey === webhookHandlerServ.serviceKey })
                    if (webhookHandlerFind) {
                        selectedWebhookHandler = webhookHandlerFind.name
                    }
                }
                nodeDetail.data.propertyDetails.requestService = {
                    serviceKey: nodeDetail.data.propertyDetails.requestService ? nodeDetail.data.propertyDetails.requestService.serviceKey : null,
                    serviceName: nodeDetail.data.propertyDetails.requestService ? nodeDetail.data.propertyDetails.requestService.serviceName : null
                }
                nodeDetail.data.propertyDetails.webhookHandler = {
                    serviceKey: nodeDetail.data.propertyDetails.webhookHandler ? nodeDetail.data.propertyDetails.webhookHandler.serviceKey : null,
                    serviceName: nodeDetail.data.propertyDetails.webhookHandler ? nodeDetail.data.propertyDetails.webhookHandler.serviceName : null
                }
            }

            name = propertyDetails.name || nodeDetail.id
            fKey = nodeDetail.data.propertyDetails.formKey || null
            serv = nodeDetail.data.propertyDetails.requestService || {}
            webhookServ = nodeDetail.data.propertyDetails.webhookHandler || {}
            eSub = propertyDetails.emailSubject || ""
            eBody = propertyDetails.emailBody || ""
            acl = propertyDetails.variableAcl || {}
        }

        const findNextNode = elements.filter((el: any) => { return (el.source === nodeDetail.id) })
        if (findNextNode.length) {
            setNextNode(findNextNode[0].target)
        } else {
            setNextNode("")
        }
        setName(name);
        setWebHookName(name)
        setSelectedForm(sForm);
        setFormKey(fKey)
        setApiResponseHandler(sService)
        setWebhookHandler(selectedWebhookHandler)
        setApiResponseHandlerService(serv)
        setWebhookHandlerService(webhookServ)
        setEmailSubject(eSub)
        setEmailBody(eBody)
        setVariableAcl(acl)
        setWebHookProperty({
            nodeId: nodeDetail.id,
            name: name,
            nextNode: findNextNode.length ? findNextNode[0].target : "",
            selectedForm: sForm,
            apiResponseHandler: serv,
            webhookHandler: webhookServ,
            service: serv,
            formKey: fKey,
            emailSubject: eSub,
            emailBody: eBody,
            variableAcl: acl
        })
    }, [nodeDetail.id, widgetDrawer])

    const saveWebHook = () => {
        props.setWidgetDrawer(false)
        setWebHookProperty({
            nodeId: nodeDetail.id,
            name: name,
            formKey: formKey,
            selectedForm: selectedForm,
            apiResponseHandler: apiResponseHandlerService,
            webhookHandler: webhookHandlerService,
            idChange: true,
            nextNode: nextNode,
            emailSubject: emailSubject && emailSubject.trim(),
            emailBody: emailBody && emailBody.trim(),
            variableAcl
        })
    }


    return ( <>
        {!showVariableAcl && <>
            <div style={{ display: "flex", flexDirection: "column" }} >
                <div className={style.conditionInput}>
                    <div style={{ width: "100%" }}>
                        <div className={style.label}>
                            <label >Name</label>
                        </div>
                        <Input
                            disabled={props.lock}
                            style={{ width: "100%", height: "44px", color: "#000610", fontSize: 15, border: props.nameCheck ? "1px solid #FF0000" : "1px solid #909BAD" }}
                            value={name}
                            placeholder="Enter Node Name"
                            onChange={(e: any) => { setName(e.target.value); setWebHookName(e.target.value) }}
                        />
                        {(props.nameCheck || !name) && <p style={{
                            color: "#FF0000",
                            opacity: props.nameCheck || !name ? 1 : 0,
                            position: "relative",
                            textAlign: "center",
                            margin: "5px",
                            fontSize: 14
                        }}>{!name ? "Name shouldn't be empty" : "Name already exists"}</p>}
                    </div>
                </div>
                <div style={{ borderBottom: "1px solid rgb(202, 213, 233)", margin: "20px 20px" }}></div>
            </div>
            <div style={{ maxHeight: window.innerHeight - 350, overflow: "auto" }}>
                <div style={{ display: "flex", flexDirection: "column", width: "100%", padding: "0px 15px" }}>
                    <div
                        className={style.label}
                        style={{ color: "#3c434a" }}
                    >
                        <label >Next Node</label>
                    </div>
                    <Select
                        showSearch
                        onChange={(e: any) => setNextNode(e)}
                        suffixIcon={<Icon style={{ fontSize: "20px", margin: -5 }} type="caret-down" />}
                        disabled={props.lock}
                        value={nextNode || undefined}
                        placeholder="Select the next node"
                        optionLabelProp="label"
                        style={{
                            width: "100%",
                            borderRadius: 8,
                            color: "#000610",
                            fontSize: 15
                        }}
                        mode="default"
                        size="large"
                        filterOption={(input, option: any) => {
                            return (option && option.props)
                                ?
                                option.props.label.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0
                                : false
                        }}
                    >
                        {nodes && nodes.map((el: any) => {
                            return <Option
                                key={el.id}
                                value={el.id}
                                label={el && el.data && el.data.propertyDetails && el.data.propertyDetails && el.data.propertyDetails.name || el.id}>
                                <div
                                    style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                    <div
                                        style={{ display: "flex", flexDirection: "row" }}>
                                        <img alt="icons" src={el.data.icon} />
                                        <p
                                            style={{
                                                marginLeft: "8px",
                                                marginTop: "14px",
                                                color: el.id === nextNode ? "#0F66C8" : "#000610"
                                            }}
                                        >
                                            {el && el.data && el.data.propertyDetails && el.data.propertyDetails && el.data.propertyDetails.name || el.id}
                                        </p>
                                    </div>
                                    {el.id === nextNode &&
                                        < Icon type="check" style={{ color: "#0F66C8" }} />}
                                </div>
                            </Option>
                        })}
                    </Select>
                </div>
                <div style={{ borderBottom: "1px solid rgb(202, 213, 233)", margin: "20px 20px" }}></div>
                <div className={style.conditionInput}>
                    <div style={{ width: "100%" }}>
                        <div className={style.label} style={{ fontSize: "15px", fontWeight: "bold" }}>
                            <label >Request</label>
                        </div>
                    </div>
                </div>
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", padding: "10px 15px 0px 15px" }}>
                    <div className={style.label} >
                        <label>Request Service</label>
                    </div>
                    <Select
                        showSearch
                        suffixIcon={<Icon style={{ fontSize: "20px", margin: "-5px" }} type="caret-down" />}
                        disabled={props.lock}
                        placeholder="Select the custom service"
                        value={apiResponseHandler || undefined}
                        size="large"
                        style={{
                            width: "100%",
                            borderRadius: 8,
                            //border: "1px solid #CAD5E9",
                            color: "#000610",
                            fontSize: 15,
                        }}
                        optionLabelProp="label"
                        onChange={(e: any) => setApiResponseHandler(e)}
                        filterOption={(input, option: any) => {
                            return (option && option.props && option.props.children) ?
                                option.props.children.props.children[0].props.children.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0
                                : false
                        }}
                    >
                        {soloServices && soloServices.map((item: any) => {
                            return <Option
                                key={item.id}
                                value={item.name}
                                label={item.name}>
                                <div
                                    style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                    <p style={{ marginTop: "10px", color: item.name === apiResponseHandler ? "#0F66C8" : "#000610" }}>
                                        {item.name}
                                    </p>
                                    {item.name === apiResponseHandler &&
                                        < Icon type="check" style={{ color: "#0F66C8" }} />}
                                </div>
                            </Option>
                        })}
                    </Select>
                </div>
                <div style={{ borderBottom: "1px solid rgb(202, 213, 233)", margin: "20px 20px" }}></div>
                <div className={style.conditionInput}>
                    <div style={{ width: "100%" }}>
                        <div className={style.label} style={{ fontSize: "15px", fontWeight: "bold" }}>
                            <label >Waiting</label>
                        </div>
                    </div>
                </div>
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", padding: "5px 15px", marginBottom: 20 }}>
                    <div className={style.label} >
                        <label>Waiting Form Screen</label>
                    </div>
                    <Select
                        showSearch
                        suffixIcon={<Icon style={{ fontSize: "20px", margin: "-5px" }} type="caret-down" />}
                        disabled={props.lock}
                        placeholder="Select the form"
                        value={selectedForm || undefined}
                        size="large"
                        style={{
                            width: "100%",
                            borderRadius: 8,
                            //border: "1px solid #CAD5E9",
                            color: "#000610",
                            fontSize: 15,
                        }}
                        optionLabelProp="label"
                        onChange={(e: any) => setSelectedForm(e)}
                        filterOption={(input, option: any) => {
                            return (option && option.props && option.props.children) ?
                                option.props.children.props.children[0].props.children.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0
                                : false
                        }}
                    >
                        {forms && forms.map((item: any) => {
                            return <Option
                                key={item.formId}
                                value={item.formName}
                                label={item?.displayName || item.formName}>
                                <div
                                    style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                    <p style={{ marginTop: "10px", color: item.formName === selectedForm ? "#0F66C8" : "#000610" }}>
                                        {item?.displayName || item.formName}
                                    </p>
                                    {item.formName === selectedForm &&
                                        < Icon type="check" style={{ color: "#0F66C8" }} />}
                                </div>
                            </Option>
                        })}
                    </Select>
                </div>
                <div style={{ borderBottom: "1px solid rgb(202, 213, 233)", margin: "20px 20px" }}></div>
                <div className={style.conditionInput}>
                    <div style={{ width: "100%" }}>
                        <div className={style.label} style={{ fontSize: "15px", fontWeight: "bold" }}>
                            <label >Completion</label>
                        </div>
                    </div>
                </div>
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", padding: "10px 15px 0px 15px" }}>
                    <div className={style.label} >
                        <label>Webhook Handler</label>
                    </div>
                    <Select
                        showSearch
                        suffixIcon={<Icon style={{ fontSize: "20px", margin: "-5px" }} type="caret-down" />}
                        disabled={props.lock}
                        placeholder="Select the custom service"
                        value={webhookHandler || undefined}
                        size="large"
                        style={{
                            width: "100%",
                            borderRadius: 8,
                            //border: "1px solid #CAD5E9",
                            color: "#000610",
                            fontSize: 15,
                        }}
                        optionLabelProp="label"
                        onChange={(e: any) => setWebhookHandler(e)}
                        filterOption={(input, option: any) => {
                            return (option && option.props && option.props.children) ?
                                option.props.children.props.children[0].props.children.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0
                                : false
                        }}
                    >
                        {soloServices && soloServices.map((item: any) => {
                            return <Option
                                key={item.id}
                                value={item.name}
                                label={item.name}>
                                <div
                                    style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                    <p style={{ marginTop: "10px", color: item.name === webhookHandler ? "#0F66C8" : "#000610" }}>
                                        {item.name}
                                    </p>
                                    {item.name === webhookHandler &&
                                        < Icon type="check" style={{ color: "#0F66C8" }} />}
                                </div>
                            </Option>
                        })}
                    </Select>
                </div>
                <div className={style.conditionInput}>
                    <div style={{ width: "100%" }}>
                        <div className={style.label}>
                            <label >Email Subject</label>
                        </div>
                        <Input
                            disabled={props.lock}
                            style={{
                                width: "100%",
                                height: "44px",
                                color: "#000610",
                                fontSize: 15,
                                border: "1px solid #909BAD"
                            }}
                            value={emailSubject}
                            placeholder="Enter email subject"
                            onChange={(e: any) => { setEmailSubject(e.target.value) }}
                            onBlur={() => emailSubject && setEmailSubject(emailSubject.trim())}
                        />
                    </div>
                </div>
                <div className={style.conditionInput} style={{ paddingTop: 10, marginBottom: 20 }}>
                    <div style={{ width: "100%" }}>
                        <div className={style.label}>
                            <label >Email Body</label>
                        </div>
                        <Input
                            disabled={props.lock}
                            style={{
                                width: "100%",
                                height: "44px",
                                color: "#000610",
                                fontSize: 15,
                                border: "1px solid #909BAD"
                            }}
                            value={emailBody}
                            readOnly={true}
                            placeholder="Enter email body"
                            onClick={() => setShowEmailBodyEditor(true)}
                            onChange={(e: any) => { setEmailBody(e.target.value) }}
                        />
                    </div>
                    {showEmailBodyEditor && <CodeEditor
                        id="emailBody"
                        handleExpression={(id: any, val: any) => setEmailBody(val.trim())}
                        lang="html"
                        values={emailBody}
                        close={() => setShowEmailBodyEditor(false)} />}
                    {((emailSubject && !emailBody) || (emailBody && !emailSubject)) && <p style={{
                        color: "red",
                        position: "relative",
                        textAlign: "center",
                        margin: "5px",
                        fontSize: 14
                    }}>{"Missing email notification details"}</p>}
                </div>
            </div>
            {<div className={style.footer}>
                {!props.nameCheck && !props.lock && <Button
                    disabled={!name || ((emailSubject && !emailBody) || (emailBody && !emailSubject))}
                    style={{
                        backgroundColor: "#51808C",
                        color: "#FFFFFF",
                        width: "100%",
                        height: 50
                    }}
                    onClick={saveWebHook} >APPLY</Button>}
            </div>
            }
            </>}
            {showVariableAcl && <VariableAcl
                variableAcl={variableAcl}
                setVariableAcl={setVariableAcl}
                teardownActiveTab={teardownActiveTab}
                setTeardownActiveTab={setTeardownActiveTab}
                setupActiveTab={setupActiveTab}
                setSetupActiveTab={setSetupActiveTab}
                setShowVariableAcl={setShowVariableAcl}
                name={name}
                lock={props.lock}>
            </VariableAcl>}
        </>)
}

export default WebHook;